import {Component, Input} from '@angular/core';
import {FormGroup, ReactiveFormsModule} from '@angular/forms';
import {EmTranslatePipe} from '@emma-labs/shared/angular';
import {LANGUAGE_OPTIONS} from '@emma-labs/shared/typescript';
import {CardModule} from 'primeng/card';
import {DropdownModule} from 'primeng/dropdown';
import {InputTextModule} from 'primeng/inputtext';
import {ClientForm} from '../quote-comparator.component';

@Component({
  selector: 'em-quote-comparator-client-section',
  templateUrl: './client-section.component.html',
  imports: [CardModule, ReactiveFormsModule, DropdownModule, InputTextModule, EmTranslatePipe],
})
export class QuoteComparatorClientSectionComponent {
  @Input({required: true}) form!: FormGroup<ClientForm>;

  readonly languageOptions = LANGUAGE_OPTIONS;
}
